import React from 'react';
import globalGetPadding from '../../utils/getPadding';

function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
    }
    return undefined;
}

const HeadingPropsDefaults = {
  level: 'h2',
  text: '',
};

export function CustomHeading({ formClientWidth, props, style }) {
    const isMobile = formClientWidth <= 480;
    const level = props?.level ?? HeadingPropsDefaults.level;
    const text = props?.text ?? HeadingPropsDefaults.text;
    const hStyle = {
        color: style?.color ?? undefined,
        backgroundColor: style?.backgroundColor ?? undefined,
        fontWeight: style?.fontWeight ?? 'bold',
        textAlign: style?.textAlign ?? undefined,
        margin: 0,
        fontFamily: getFontFamily(style?.fontFamily),
        fontSize: getFontSize(level, isMobile),
        padding: globalGetPadding(style?.padding, isMobile),
    };
    switch (level) {
        case 'h1':
            return <h1 style={hStyle}>{text}</h1>;
        case 'h2':
            return <h2 style={hStyle}>{text}</h2>;
        case 'h3':
            return <h3 style={hStyle}>{text}</h3>;
    }
}

function getFontSize(level, isMobile) {
    switch (level) {
        case 'h1':
            return isMobile ? 24 : 32;
        case 'h2':
            return isMobile ? 20 : 24;
        case 'h3':
            return isMobile ? 16 : 20;
    }
}
